import AutoClampTypography from "./helpers/AutoClampTypography/AutoClampTypography";
import AutoLayout from "./helpers/AutoLayout/AutoLayout";
import AutoLayoutItem from "./helpers/AutoLayout/components/Item/Item";
import Carousel from "./widgets/Carousel/Carousel";
import Chart from "./widgets/Chart/Chart";
import ControlledTreeSelect from "./widgets/TreeSelect/ControlledTreeSelect";
import Disclaimer from "./components/Disclaimer/Disclaimer";
import Drawer from "./overlays/Drawer/Drawer";
import ErrorPage from "./widgets/ErrorPage";
import ExportButton from "./components/ExportButton/ExportButton";
import HowToModal from "./widgets/HowToModal/HowToModal";
import IllustrativeIcon from "./icons/IllustrativeIcon/IllustrativeIcon";
import LazyLoadComponent from "./helpers/LazyLoadComponent/LazyLoadComponent";
import LetterformSpinner from "./logos/LetterformSpinner/LetterformSpinner";
import MdcIconButton from "./theme/styledComponents/MdcIconButton";
import MdcMuiTab from "./theme/styledComponents/MdcMuiTab";
import MdcMuiTabs from "./theme/styledComponents/MdcMuiTabs";
import MdcTable from "./table/MdcTable/table";
import MdcTabs from "./navigation/MdcTabs/MdcTabs";
import MdcToggleButton from "./theme/styledComponents/MdcToggleButton";
import MdcToggleIconButton from "./theme/styledComponents/MdcToggleIconButton";
import MicroFrontendLoader from "./helpers/MicroFrontendLoader";
import Modal from "./overlays/Modal/Modal";
import MoodysLogo from "./logos/MoodysLogo";
import MoodysThemeProvider from "./theme/muiThemes/MoodysThemeProvider/MoodysThemeProvider";
import Scrim from "./overlays/Scrim/Scrim";
import SearchResultsPeers from "./widgets/SearchResultsPeers/SearchResultsPeers";
import SelectableChip from "./widgets/SelectableChip/SelectableChip";
import SingleSelectChip from "./widgets/SingleSelectChip/SingleSelectChip";
import SkeletonGenerator from "./helpers/SkeletonGenerator/SkeletonGenerator";
import Snackbar from "./overlays/Snackbar/Snackbar";
import UncontrolledTreeSelect from "./widgets/TreeSelect/UncontrolledTreeSelect";
import WidgetCard from "./widgets/WidgetCard/WidgetCard";
import analytics from "./services/analytics";
import appContextProviderGenerator from "./utils/appContextProviderGenerator/appContextProviderGenerator";
import axiosBaseQuery from "./utils/rtk/axiosBaseQuery";
import carouselModule from "./widgets/Carousel";
import chartModule from "./widgets/Chart";
import colors from "./theme/colors";
import componentThemes from "./theme/muiThemes/componentThemes";
import cookie from "./utils/cookie";
import createTranslations from "./utils/createTranslations/createTranslations";
import eventBus from "./utils/eventBus";
import excelExport from "./utils/excelExport";
import fetcher from "./services/fetcher";
import fonts from "./theme/muiThemes/fonts";
import frontendLogger from "./services/logger/frontendLogger";
import htmlSanitizer from "./utils/htmlSanitizer";
import jsonHelpers from "./utils/jsonHelpers";
import mdcTableConstants from "./table/MdcTable/constants";
import mdcTableFilters from "./table/MdcTable/filters";
import mdcTableUtils from "./table/MdcTable/utils";
import mdcTableValueFormatters from "./table/MdcTable/valueFormatters";
import number from "./utils/number";
import routerCache from "./helpers/routerCache";
import split from "./services/split";
import string from "./utils/string";
import treeSelectModule from "./widgets/TreeSelect";
import urlBuilders from "./utils/urlBuilders";
import useMediaKey from "./helpers/AutoLayout/hooks/useMediaKey";
import widgetCardModule from "./widgets/WidgetCard";
import { logger } from "./services/logger";

export interface RemoteExports {
  AutoClampTypography: typeof AutoClampTypography;
  AutoLayout: typeof AutoLayout;
  AutoLayoutItem: typeof AutoLayoutItem;
  Carousel: typeof Carousel;
  Chart: typeof Chart;
  ControlledTreeSelect: typeof ControlledTreeSelect;
  Disclaimer: typeof Disclaimer;
  Drawer: typeof Drawer;
  ErrorPage: typeof ErrorPage;
  ExportButton: typeof ExportButton;
  HowToModal: typeof HowToModal;
  IllustrativeIcon: typeof IllustrativeIcon;
  LazyLoadComponent: typeof LazyLoadComponent;
  LetterformSpinner: typeof LetterformSpinner;
  MdcIconButton: typeof MdcIconButton;
  MdcMuiTab: typeof MdcMuiTab;
  MdcMuiTabs: typeof MdcMuiTabs;
  MdcTable: typeof MdcTable;
  MdcTabs: typeof MdcTabs;
  MdcToggleButton: typeof MdcToggleButton;
  MdcToggleIconButton: typeof MdcToggleIconButton;
  MicroFrontendLoader: typeof MicroFrontendLoader;
  Modal: typeof Modal;
  MoodysLogo: typeof MoodysLogo;
  MoodysThemeProvider: typeof MoodysThemeProvider;
  Scrim: typeof Scrim;
  SearchResultsPeers: typeof SearchResultsPeers;
  SelectableChip: typeof SelectableChip;
  SingleSelectChip: typeof SingleSelectChip;
  SkeletonGenerator: typeof SkeletonGenerator;
  Snackbar: typeof Snackbar;
  UncontrolledTreeSelect: typeof UncontrolledTreeSelect;
  WidgetCard: typeof WidgetCard;
  analytics: typeof analytics;
  appContextProviderGenerator: typeof appContextProviderGenerator;
  axiosBaseQuery: typeof axiosBaseQuery;
  carouselModule: typeof carouselModule;
  chartModule: typeof chartModule;
  colors: typeof colors;
  componentThemes: typeof componentThemes;
  cookie: typeof cookie;
  createTranslations: typeof createTranslations;
  eventBus: typeof eventBus;
  excelExport: typeof excelExport;
  fetcher: typeof fetcher;
  fonts: typeof fonts;
  frontendLogger: typeof frontendLogger;
  htmlSanitizer: typeof htmlSanitizer;
  jsonHelpers: typeof jsonHelpers;
  mdcTableConstants: typeof mdcTableConstants;
  mdcTableFilters: typeof mdcTableFilters;
  mdcTableUtils: typeof mdcTableUtils;
  mdcTableValueFormatters: typeof mdcTableValueFormatters;
  number: typeof number;
  routerCache: typeof routerCache;
  split: typeof split;
  string: typeof string;
  treeSelectModule: typeof treeSelectModule;
  urlBuilders: typeof urlBuilders;
  useMediaKey: typeof useMediaKey;
  widgetCardModule: typeof widgetCardModule;
  logger: typeof logger;
}

export enum RemoteScopes {
  AutoClampTypography = "helpers",
  AutoLayout = "helpers",
  AutoLayoutItem = "helpers",
  Carousel = "widgets",
  Chart = "widgets",
  ControlledTreeSelect = "widgets",
  Disclaimer = "components",
  Drawer = "overlays",
  ErrorPage = "widgets",
  ExportButton = "components",
  HowToModal = "widgets",
  IllustrativeIcon = "icons",
  LazyLoadComponent = "helpers",
  LetterformSpinner = "logos",
  MdcIconButton = "theme",
  MdcMuiTab = "theme",
  MdcMuiTabs = "theme",
  MdcTable = "table",
  MdcTabs = "navigation",
  MdcToggleButton = "theme",
  MdcToggleIconButton = "theme",
  MicroFrontendLoader = "helpers",
  Modal = "overlays",
  MoodysLogo = "logos",
  MoodysThemeProvider = "theme",
  Scrim = "overlays",
  SearchResultsPeers = "widgets",
  SelectableChip = "widgets",
  SingleSelectChip = "widgets",
  SkeletonGenerator = "helpers",
  Snackbar = "overlays",
  UncontrolledTreeSelect = "widgets",
  WidgetCard = "widgets",
  analytics = "services",
  appContextProviderGenerator = "utils",
  axiosBaseQuery = "utils",
  carouselModule = "widgets",
  chartModule = "widgets",
  colors = "theme",
  componentThemes = "theme",
  cookie = "utils",
  createTranslations = "utils",
  eventBus = "utils",
  excelExport = "utils",
  fetcher = "services",
  fonts = "theme",
  frontendLogger = "services",
  htmlSanitizer = "utils",
  jsonHelpers = "utils",
  mdcTableConstants = "table",
  mdcTableFilters = "table",
  mdcTableUtils = "table",
  mdcTableValueFormatters = "table",
  number = "utils",
  routerCache = "helpers",
  split = "services",
  string = "utils",
  treeSelectModule = "widgets",
  urlBuilders = "utils",
  useMediaKey = "helpers",
  widgetCardModule = "widgets",
}

export type RemoteExportsKeys = keyof RemoteExports;

export interface HmrConfig {
  enabled: boolean;
  host: string;
  port: number;
  reconnectInterval: number;
}

export interface Module {
  scope: string;
  preload?: boolean;
}

export type RemoteModuleList<K extends string> = Partial<Record<K, Module>>;

export interface FederatedConsumerConfig<K extends string> {
  name: string;
  hmr?: HmrConfig;
  localPort?: number;
  remoteModules: RemoteModuleList<K>;
  shared?: Record<string, { version: string; module: Promise<unknown> }>;
  logger?: Logger;
}
